import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import ResultTab, { ResultMenuType } from '@components/acca/results/result/resultTab';
import { ResultStoreProvider } from '@components/acca/results/result/resultStoreProvider';
import ApplyResult from '@components/acca/results/result/applyResult';
import CompetencyResult from '@components/acca/results/result/competencyResult';
import Title from '@components/acca/cc/result/title';
import { accaResultAxios } from '@repository/publicAcc/AccaResultAxios';
import { useAccaPublicTestResultStore } from '@stores/AccaPublicTestResultStore';
import DeepResult from '../../results/result/deepResult';
import { VersionType } from '../../../../domain/constant/acca/VersionType';
import { PublicAccApplyUserStatusVO } from '../../../../domain/vo/acca/v1/test/result/PublicAccApplyUserStatusVO';
import { AnalysisType } from '@domain/constant/analysisType';
import useOnMount from '@utils/hooks/useOnMount';
import classnames from 'classnames/bind';
import styles from './result.module.scss';

const cx = classnames.bind(styles);

// CC(커리어 센터)에서 불러오는 결과표
const CCResult = () => {
  const [resultState, setResultState] = useState<AnalysisType | null>(null);
  const [resultMenu, setResultMenu] = useState<ResultMenuType>('APPLY');
  const [version, setVersion] = useState<VersionType | null>(null);
  const [userStatus, setUserStatus] = useState<PublicAccApplyUserStatusVO | null>(null);

  const fetchAccStatusUser = useAccaPublicTestResultStore((state) => state.fetchAccStatusUser);
  const publicAccApplyUserStatus = useAccaPublicTestResultStore((state) => state.publicAccApplyUserStatus);
  const accResult = useAccaPublicTestResultStore((state) => state.accResult);
  const isV3Result = publicAccApplyUserStatus?.version === 'V3';

  useEffect(() => {
    if (!accResult) return;
    setResultState(accResult.analysisType);
  }, [accResult]);

  useOnMount(() => {
    init();
  });

  const init = async () => {
    const accessToken = Cookies.get('cc-accessToken');

    if (accessToken) {
      accaResultAxios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }

    const data = await fetchAccStatusUser();
    setUserStatus(new PublicAccApplyUserStatusVO(data));
    setVersion(data.version);
  };

  const getResult = () => {
    switch (resultMenu) {
      // 응시 분석 결과
      case 'APPLY':
        return (
          <ApplyResult
            resultState={resultState}
            setResultState={setResultState}
            version={version}
            resultMenu={resultMenu}
          />
        );
      // 역량 분석 결과
      case 'COMPETENCY':
        return <CompetencyResult version={version} resultMenu={resultMenu} />;
      // 심층 분석 결과(v3만 해당)
      case 'DEEP':
        return <DeepResult />;
    }
  };

  if (!version) return null;

  return (
    <div className={cx('wrap', { v3: isV3Result })}>
      {/* [D] 이름 학교 전공 영역 */}
      <Title userStatus={userStatus} />

      {/* [D] 결과표 영역 */}
      <div className={cx('resultArea')}>
        <ResultTab resultState={resultState} resultMenu={resultMenu} setResultMenu={setResultMenu} version={version} />

        {/* [D] 결과표 영역 */}
        <ResultStoreProvider isPublicStore>{getResult()}</ResultStoreProvider>
      </div>
    </div>
  );
};

export default CCResult;
